import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react';
import routes from '../routes';
import { ActiveLinkContext } from './ActiveLinkContext';


const AppBreadcrumb = () => {
  const currentLocation = useLocation().pathname;
  const { activeLink } = useContext(ActiveLinkContext);


  const getRouteName = (pathname, routes) => {
    const currentRoute = routes.find((route) => route.path === pathname);
    return currentRoute ? currentRoute.name : false;
  };

  const getBreadcrumbs = (location) => {
    const breadcrumbs = [];
    location.split('/').reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`;
      const routeName = getRouteName(currentPathname, routes);
      routeName &&
        breadcrumbs.push({
          pathname: currentPathname,
          name: routeName,
          active: index + 1 === array.length ? true : false,
        });
      return currentPathname;
    });
    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(currentLocation);

  return (
     <CBreadcrumb className="m-0 ms-2">
      <CBreadcrumbItem href="/dashboard">Home</CBreadcrumbItem>
      {activeLink && (
        <CBreadcrumbItem active>
          {activeLink.charAt(0).toUpperCase() + activeLink.slice(1)}
        </CBreadcrumbItem>
      )}
    </CBreadcrumb>
  );
};

export default React.memo(AppBreadcrumb);
